'use strict';

angular.module('cloudBillingLegacyFrontend').service('$eaConfig', function(envDeployment, $q) {
  var self = this;

  self.getConfiguration = function() {
    if (window.appConfig) { 

      // inject the application specific config
      window.appConfig.deployment = envDeployment;

      // generate the cdn entrypoint
      window.appConfig.cdnEntrypoint = undefined;
      if (window.appConfig.cdn) {
        window.appConfig.cdnEntrypoint = 'https://' + window.appConfig.deployment[window.appConfig.cdn];
      }

      // generate the data path      
      window.appConfig.dataPath = '/cb1/app/data';
      if (window.appConfig.envType !== 'local') {
        window.appConfig.dataPath += '-' + window.appConfig.deployment.deploymentUUID;
      } else {
        window.appConfig.dataPath = '/app/data';
      }

      // generate the svps styles path      
      window.appConfig.svpStylesPath = '/cb1/app/styles-svps';
      if (window.appConfig.envType !== 'local') {
        window.appConfig.svpStylesPath += '-' + window.appConfig.deployment.deploymentUUID;
      }

      // ensure we have at least one boost host
      if (!window.appConfig.apiBoostHosts || window.appConfig.apiBoostHosts.length === 0) {
        window.appConfig.apiBoostHosts = [window.appConfig.apiHost];
      }
  
      // allow to enable and disable ri functionaliy
      window.appConfig.riEnabled = false;

      // inject a correct svp contact information 
      if (!window.appConfig.svp) { window.appConfig.svp = {}; }
      if (!window.appConfig.svp.contact) { window.appConfig.svp.contact = 'support@mevodo.com'; }      

      // done
      return window.appConfig;
    } else {
      alert('No config available');
      return undefined;
    }
  };  

  // inject some helper function
  self.verifyFeature = function(feature) {
    if (self.getConfiguration().features[feature] === true) {
      return $q.when(true);
    } else {
      return $q.reject(new Error(feature + ' not enabled'));
    }
  };

  return self;
});
